export enum PaymentTypesEnum {
  CASH = "CASH",
  CARD = "CARD",
  ANY = "ANY",
  HIDDEN = "HIDDEN",
}
